import * as tslib_1 from "tslib";
import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment';
var AppDateAdapter = /** @class */ (function (_super) {
    tslib_1.__extends(AppDateAdapter, _super);
    function AppDateAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppDateAdapter.prototype.getFirstDayOfWeek = function () {
        return 1;
    };
    AppDateAdapter.prototype.parse = function (value) {
        var date = moment(value, 'DD.MM.YYYY', true);
        if (!date.isValid()) {
            return null;
        }
        return date.toDate();
    };
    AppDateAdapter.prototype.format = function (date, displayFormat) {
        if (displayFormat === 'input') {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return this.parseDigit(day) + "." + this.parseDigit(month) + "." + year;
        }
        return _super.prototype.format.call(this, date, displayFormat);
    };
    AppDateAdapter.prototype.parseDigit = function (n) {
        return ('00' + n).slice(-2);
    };
    return AppDateAdapter;
}(NativeDateAdapter));
export { AppDateAdapter };
